import {useEffect} from 'react'
import {useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import {hasAnyRole} from "../authHelper.js";

/**
 * Guard hook that sends user to rootpage if not in allowedRoles.
 * Waits for the DB role to have loaded (state.user.roleLoaded) before evaluating,
 * so it doesn't redirect based on the not-yet-fetched default role.
 * @param allowedRoles
 */
export default function useNavigationGuardByRole(allowedRoles) {
    const role = useSelector(state => state.user.user.role);
    const roleLoaded = useSelector(state => state.user.roleLoaded);
    const navigate = useNavigate();
    useEffect(() => {
        if (roleLoaded && !hasAnyRole(role, allowedRoles)) {
            navigate("/")
        }
    }, [roleLoaded, role])
}
